export default "__VITE_ASSET__1l1zZdKr__"